/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SEOStrapiService } from '../../../common/services/seo-strapi.service';
import { ApolloQueryResult } from '@apollo/client/core/types';
import { ISEOLandingPageCollection } from '../../interfaces/seo-landing-page-collection.interface';
import { Observable, catchError, map, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'vm-page-urls-shell',
  templateUrl: './page-urls-shell.component.html',
  styleUrls: ['./page-urls-shell.component.scss'],
})
export class PageUrlsShellComponent implements OnInit {
  urls = new Array<string>();
  urlString: string;

  constructor(
    private seoStrapiService: SEOStrapiService,
    private http: HttpClient
  ) {}
  
  ngOnInit(): void {

    this.seoStrapiService.getPageUrls().subscribe((results: ApolloQueryResult<ISEOLandingPageCollection>) => {
      results?.data?.seoLandingPages?.forEach((element, index) => {
        //this.checkPage(`https://whoosh.int.virginmediao2.co.uk/help/how-to${element?.pageUrl}`).subscribe((isValid) => {
        //  if (isValid) {
            this.urls.push(element?.pageUrl);
        //  }          
        //});
      });
      this.urls.sort();
      this.urlString = this.urls.join(',');
    });
  }

  checkPage(url: string): Observable<boolean> {
    return this.http.get(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  sortDataByField(fieldName: string) {
    this.urls.sort((a, b) => {
      const nameA = a[fieldName].toLowerCase();
      const nameB = b[fieldName].toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }
  sortDataByFieldLength(fieldName: string) {
    this.urls.sort((a, b) => {
      const nameA = a[fieldName].length();
      const nameB = b[fieldName].length();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }
}
